import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StockDetailService } from '../../../../Services/Stock-Details/stock-detail.service';
import { HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../Services/auth.service';

interface StockItem {
  std_item_code: string;
  std_barcode: string;
  std_item_category: string;
  std_total_wt: number;
  std_quantity: number;
  issued_stock_id: number | null;
  owner: string;
  std_entry_date: string;
  status: 'Assigned' | 'Pending' | 'Submitted' | 'Sold';
}

@Component({
  selector: 'app-new-stock',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './new-stock.component.html',
  styleUrl: './new-stock.component.css'
})
export class NewStockComponent {

  constructor(private stockDetailService:StockDetailService,private authService:AuthService){}
  
  // Pagination State
  currentPage: number = 1;
  itemsPerPage: number = 10;
  loggedInUserId!: number;
  returnReason: string = '';
  selectedItemId: number | null = null;

  // dummy data generator (24 items to show 3 pages)
  stockItems: any;

  ngOnInit(){
    this.loggedInUserId = this.authService.getUserId();
    this.getNewStockData();
  }

  getNewStockData() {
    let params = new HttpParams().set('stock_status', 'in');

    if (this.authService.getUserRole() === 'Staff') {
      if (this.authService.getUserStaffType() === 'Field') {
        params = params.set('issued_stock_id', this.authService.getUserId());
      }
    }

    this.stockDetailService.getStockDetails(params).subscribe((response: any) => {

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      this.stockItems = response.data.filter((item: any) => {
        if (!item.updated_at) return false;

        const entryDate = new Date(item.updated_at);
        entryDate.setHours(0, 0, 0, 0);

        return entryDate.getTime() === today.getTime();
      });

      console.log('✅ Filtered today stock:', this.stockItems);
    });
  }

  // Getters for Pagination
  get visibleItems(): StockItem[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.stockItems.slice(startIndex, startIndex + this.itemsPerPage);
  }

  get totalItems(): number {
    return this.stockItems.length;
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  get startRange(): number {
    if (this.totalItems === 0) return 0;
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  get endRange(): number {
    return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  }

  openReturn(item: any) {
    this.selectedItemId = item.std_id;
    this.returnReason = '';
  }

  submitReturn() {
    if (!this.selectedItemId || !this.returnReason.trim()) {
      alert('Reason is required');
      return;
    }

    this.stockDetailService
      .returnStock(this.selectedItemId, this.returnReason)
      .subscribe(() => {
        alert('Stock returned successfully');
        this.getNewStockData();
        this.selectedItemId = null;
      });
  }

  // Navigation Methods
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
  
  firstPage() {
    this.currentPage = 1;
  }

  lastPage() {
    this.currentPage = this.totalPages;
  }
}